import { Record, Map } from 'immutable';

import { PRODUCTS } from '../../constants';

import {
  SET_PROMO_PAGE,
} from './actions';

export const Promo = new Record({
  id: '',
  title: '',
  subtitle: '',
  backgroundImage: '',
  registrationImage: '',
  videoUrl: '',
  videoTitle: '',
  listTitleField1: '',
  listTitleField2: '',
  listTitleField3: '',
  listTitleField4: '',
  listTitleField5: '',
  urlSegment: '',
  description: '',
  joinButton: false,
  trustPilotWidget: false,
  termsAndConditions: '',
  ctaPosition: '',
  bonusCode: '',
  product: PRODUCTS.exchange,
}, 'Promo');

const InitialState = new Record({
  promotions: new Map()
});

export const initialState = new InitialState();

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_PROMO_PAGE: {
      const { urlSegment } = payload;

      const updatedState = state.withMutations((mutableState) => {
        mutableState.setIn(['promotions', urlSegment], new Promo({
          ...payload
        }));

        return mutableState;
      });

      return updatedState;
    }
    default:
      return state;
  }
};
